import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

/**
 * Confirmación para Tommy (TH): marcar Offered sin enviar email.
 */
export default function EstimateTommyOfferedDialog({
  open,
  onClose,
  onConfirm,
  confirming = false,
  count = 1,
  alreadyOffered = false,
}) {
  const n = Math.max(1, Number(count) || 1);
  const plural = n > 1;

  return (
    <Dialog
      open={open}
      onClose={confirming ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <DialogTitle sx={{ fontWeight: 800 }}>Cliente Tommy (TH)</DialogTitle>
      <DialogContent>
        <DialogContentText component="div">
          {alreadyOffered ? (
            <>
              Este cliente es <strong>Tommy Hilfiger</strong>: no se envía email
              de oferta. El presupuesto ya está en Offered.
            </>
          ) : (
            <>
              Como el cliente es <strong>Tommy Hilfiger</strong>, no se envía
              email de oferta.
              {plural ? (
                <>
                  {" "}
                  ¿Marcar <strong>{n}</strong> presupuestos como{" "}
                  <strong>Offered</strong>?
                </>
              ) : (
                <>
                  {" "}
                  ¿Marcar el presupuesto como <strong>Offered</strong>?
                </>
              )}
            </>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button
          onClick={onClose}
          color="inherit"
          variant="outlined"
          disabled={confirming}
        >
          {alreadyOffered ? "Cerrar" : "Cancelar"}
        </Button>
        {!alreadyOffered ? (
          <Button
            variant="contained"
            color="primary"
            onClick={onConfirm}
            disabled={confirming}
            startIcon={
              confirming ? (
                <CircularProgress size={16} color="inherit" />
              ) : null
            }
          >
            {confirming
              ? "Marcando…"
              : plural
                ? "Marcar Offered"
                : "Marcar Offered"}
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
}
